<template>
  <span>
    <template v-for="(chunk, index) in renderTree">
      <span
        v-if="chunk.isString"
        v-bind:key="index"
        class="string_chunk"
        :class="{ 'string_chunk--disabled': disabled }"
      >
        {{ chunk.content }}
      </span>
      <slot v-else :name="chunk.name"></slot>
    </template>
  </span>
</template>

<script>
export default {
  name: "StringTemplateRenderer",
  props: {
    content: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    renderTree() {
      // Match all substrings between [[ ]].
      return this.content.split(/(\[\[.*?\]\])/).map((contlet, index) => {
        let renderChunk = {
          index,
          isString: true,
          content: contlet,
        };
        if (contlet.indexOf("[[") > -1) {
          renderChunk = {
            index,
            isSlot: true,
            name: contlet.substring(
              contlet.lastIndexOf("[[") + 2,
              contlet.lastIndexOf("]]")
            ),
          };
        }
        return renderChunk;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../style_variables/style_variables.scss";

.string_chunk {
  margin-right: 1ch;
  &.string_chunk--disabled {
    color: $grey_mischka;
  }
}
</style>
